import { useState } from 'react'

import { api } from '@/shared/services/api'

interface SecuritySettingsData {
  email?: string
  current_password?: string
  password?: string
  password_confirmation?: string
}

export function useSecuritySettings() {
  const [isLoading, setIsLoading] = useState(false)

  const updateCredentials = async (data: SecuritySettingsData) => {
    setIsLoading(true)
    try {
      await api.put('/user/update_security_settings', { record: data })
    } finally {
      setIsLoading(false)
    }
  }

  const resendEmailConfirmation = async () => {
    setIsLoading(true)
    try {
      await api.post('/user/resend_email_confirmation')
    } finally {
      setIsLoading(false)
    }
  }

  const cancelEmailChange = async () => {
    setIsLoading(true)
    try {
      const { data } = await api.delete('/user/cancel_email_change')
      return data
    } finally {
      setIsLoading(false)
    }
  }

  return {
    updateCredentials,
    resendEmailConfirmation,
    cancelEmailChange,
    isLoading
  }
}
